import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Brand from '../components/Brand';
import { authAPI } from '../lib/api';
import { setSession } from '../lib/auth';
import { t } from '../lib/i18n';

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const { data } = await authAPI.login(username.trim(), password);
      setSession(data.token, { name: data.name, role: data.role, mid: data.mid || '', mr: data.mr || null });
      navigate(['admin', 'manager'].includes(data.mr) ? '/admin/dashboard' : '/portal', { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || t('Login failed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <Brand size="lg" className="justify-center" />
          <div className="mt-2 text-sm text-mms-muted">{t('Marketing Management System')}</div>
        </div>
        <form
          onSubmit={submit}
          className="rounded-lg border border-mms-border bg-mms-surface p-6 space-y-4 shadow-[var(--mms-elev-2)]"
        >
          <div>
            <label htmlFor="mms-user" className="block text-sm text-mms-muted mb-1.5">
              {t('Username or email')}
            </label>
            <input
              id="mms-user"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              required
              className="w-full rounded-md border border-mms-border bg-mms-input px-3 py-2 text-sm outline-none focus:border-[var(--mms-focus-border)]"
            />
          </div>
          <div>
            <label htmlFor="mms-pass" className="block text-sm text-mms-muted mb-1.5">
              {t('Password')}
            </label>
            <input
              id="mms-pass"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              className="w-full rounded-md border border-mms-border bg-mms-input px-3 py-2 text-sm outline-none focus:border-[var(--mms-focus-border)]"
            />
          </div>
          {error && (
            <p role="alert" className="text-sm" style={{ color: 'var(--mms-danger)' }}>
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={busy}
            className="w-full rounded-md bg-mms-accent px-3 py-2 text-sm font-semibold text-mms-accent-ink disabled:opacity-60"
          >
            {busy ? t('Signing in…') : t('Sign in')}
          </button>
        </form>
        <p className="mt-4 text-center text-xs text-mms-faint">
          {t('Access is limited during development.')}
        </p>
      </div>
    </div>
  );
}
